const REDIRECT_KEY = 'redirectAfterEmailVerification';

const INVITATION_PREFIXES = [
  '/invitation-accept/',
  '/invitation-partner/',
  '/invitation-affiliate/',
] as const;

export function isInvitationRedirect(path: string | null | undefined): boolean {
  if (!path || typeof path !== 'string') return false;
  return INVITATION_PREFIXES.some((prefix) => path.startsWith(prefix));
}

export function getPostLoginRedirect(): string | null {
  return localStorage.getItem(REDIRECT_KEY);
}

export function setPostLoginRedirect(path: string): void {
  localStorage.setItem(REDIRECT_KEY, path);
}

export function clearPostLoginRedirect(): void {
  localStorage.removeItem(REDIRECT_KEY);
}
